import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_LOGIN_CLIENT_ID } from '../src/global/Environment';
import App from './App';

Sentry.init({
  dsn: 'https://7054ec3221354c59ef907d6b4cc984c6@o307744.ingest.us.sentry.io/4507579471626240',
  environment: process.env.REACT_APP_ENV,
  release: process.env.REACT_APP_SENTRY_RELEASE,
  debug: process.env.REACT_APP_ENV !== 'production',
  beforeSend(event, hint) {
    // If the environment is development, log the error to the console instead of sending it to Sentry
    if (process.env.REACT_APP_ENV === 'development') {
      if (hint?.originalException) {
        console.error(hint.originalException);
      } else {
        console.error(event);
      }
      return null;
    }
    return event;
  }
});

const root = createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_LOGIN_CLIENT_ID}>
    <Sentry.ErrorBoundary>
      <App />
    </Sentry.ErrorBoundary>
  </GoogleOAuthProvider>
);
